import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { node } from 'prop-types';
import {
  useEffect,
  useState,
  useRef,
} from 'react';

import { STEP } from 'views/Request/Common/constants';
import useStyles from './styles';
import TopBar from './TopBar';
import { PEOPLE_TYPE } from 'views/Request/Home/constants';
import { getUserInfo } from 'services/dynamicore/processes';

const parentRoute = '/request';

function RequestLayout(props) {
  const history = useHistory();
  const classes = useStyles();
  const isMountedRef = useRef(true);
  const [userInfo, setUserInfo] = useState();

  const { location: { pathname, search } } = history;
  const onIframe = window.self !== window.top;

  const handleBack = function () {
    const backRoute = {
      [STEP.CONFIRM]: `/${STEP.IDENTITY}`,
      [STEP.IDENTITY]: `/${STEP.CUSTOMER}`,
      [STEP.DOCUMENTATION]: `/${STEP.CONFIRM}`,
      [STEP.LOAN]: userInfo?.data?.people?.pii?.type === PEOPLE_TYPE.INDIVIDUAL ? `/${STEP.DOCUMENTATION}` : `/${STEP.CONFIRM}`,
      [STEP.REGISTER]: `/${STEP.SIMULATOR_RESULTS}${search}`,
      [STEP.SIMULATOR_RESULTS]: search,
    }[pathname.replace(/^\/request\//, '')];

    return backRoute
      ? function () {
        history.push(`${parentRoute}${backRoute}`);
      }
      : undefined;
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const objUserInfo = await getUserInfo('people');
        
        if (isMountedRef.current) {
          setUserInfo(objUserInfo);
        }
      } catch (error) {
        if (isMountedRef.current) {
          console.error('Error fetching user info in RequestLayout:', error);
        }
      }
    };

    // Solo obtener info del usuario para rutas que requieren autenticación
    const currentStep = pathname.replace(/^\/request\//, '');
    const publicSteps = [
      STEP.SIMULATOR,
      STEP.SIMULATOR_RESULTS, 
      STEP.REGISTER,
      STEP.REGISTER_CONFIRM,
    ];
    
    // Solo fetch userInfo si NO está en los pasos públicos
    if (!publicSteps.includes(currentStep) && currentStep !== '/request') {
      fetchUserInfo();
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [pathname]);

  return (
    <div className={clsx(classes.root, onIframe ? classes.root_iframe : classes.root_self)}>

      {!onIframe && (
        <TopBar
          onIframe={onIframe}
          handleBack={handleBack()}
        />
      )}

      <div className={clsx(classes.root, !onIframe && classes.wrapper_noiframe)}>
        <div className={classes.contentContainer}>
          <div
            children={props.children}
            className={classes.content}
          />
        </div>
      </div>

    </div>
  );
}

RequestLayout.propTypes = {
  children: node,
};

export default RequestLayout;
